module.exports = __webpack_public_path__ + "static/media/icon_67.78e53945.svg";